export default __webpack_public_path__ + "static/media/woo_plugin_assistant_optm.f6dd091a.svg";